<app-loader *ngIf="loaderIcon | async"></app-loader>
<form [formGroup]="loginForm">
    <div class="login-card text-center">

        <div class="login-logo mb-3">
            <img src="/assets/images/ASLogo.png" style="width: 15rem" alt="Logo">
        </div>

        <h6 class="text-welcome mb-4 visually-hidden">
            Welcome back! Please login to continue
        </h6>

        <div class="market-switch-bar mb-3" *ngIf="isNative && marketName">
            <span class="market-switch-name">{{ marketName }}</span>
            <a (click)="switchMarket()" class="market-switch-link">Switch Market</a>
        </div>

        <div class="position-relative mt-3">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                <span class="error-message" *ngIf="loginError">
                    <p i18n>User Name / Password is incorrect!</p>
                </span>
                <span class="error-message" *ngIf="inActive">
                    <p i18n>User is Inactive!</p>
                </span>
            </div>
        </div>

        <div class="position-relative" style="margin-top: 35px">
            <i class="bi bi-envelope input-icon"></i>
            <input type="text" class="form-control" placeholder="Email" formControlName="username"
                (keyup)="validateLoginCredentials()" required />
        </div>
        <div class="text-start mb-3">
            <small class="text-danger" *ngIf="displayUsernameError">Email is required</small>
        </div>

        <div class="position-relative">
            <i class="bi bi-lock input-icon"></i>
            <div class="input-group">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Password"
                    formControlName="password" (keyup)="validateLoginCredentials()" required />

                <span class="input-group-text" (click)="togglePassword()">
                    <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </span>
            </div>
        </div>
        <div class="text-start mb-3">
            <small class="text-danger" *ngIf="displayPasswordError">Password is required</small>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-4" style="margin-top: 30px;">
            <div class="form-check" style="display: none;">
                <input class="form-check-input" type="checkbox" id="remember" formControlName="rememberMe">
                <label class="form-check-label" for="remember">Remember Me</label>
            </div>
            <a (click)="ForgotPassword($event)" class="forgot-link text-primary fw-semibold">
                Forgot Password?
            </a>
        </div>

        <div class="d-flex justify-content-center">
            <button class="btn btn-warning" (click)="validateLogin()">Sign-in</button>
        </div>
    </div>
</form>